import React, { useState } from 'react'
import Allproducts from './tab/Allproducts'

const FeatureProd = () => {
    const [active, setActive] = useState("allProducts")

    const products = [
        {
            prod: 'All Products',
            active: "allProducts"
        },
        {
            prod: 'Best Sellers',
            active: "bestSellers"
        },
    ]

    const handleActiveClick = (index) => {
        setActive(index)
    }

    const tab = [
        { product: <Allproducts /> },
        { product: "COMING SOON" }

    ]
    const activeIndex = products.findIndex(item => item.active === active);


    return (
        <div className='flex flex-col bg-[#06000A] pt-[7%] lg:px-[8%] px-[4%] gap-4 z-[500] relative'>
            <p className='text-[100px] z-[100] lg:block hidden top-[50px] left-[30%] absolute text-white font-bold text-opacity-5'>CATALOUGE</p>
            <div data-aos="fade-up" className='flex w-full items-center justify-center'>
                <div className='lg:w-[50%] gap-4 w-full flex flex-col items-center justify-center'>
                    <p className='lg:text-[55px] text-[30px] text-white font-semibold '>Feature Products </p>
                    <p className='text-[14px] text-[#ffffff] text-center'>Each product is crafted to optimize efficiency, enhance sustainability, and support fair trade practices across the globe."</p>
                </div>
            </div>
            <div className='flex flex-col gap-4'>
                <div className='flex flex-row gap-4 border-b-[1px] border-blue-400'>
                    {
                        products.map((p, i) => {
                            return (
                                <div key={i} onClick={() => handleActiveClick(p.active)} className={`flex cursor-pointer text-white text-[20px] text-opacity-75 ${active === p.active ? "border-b-2 border-blue-400 text-blue-500" : ""}`}>
                                    <p>{p.prod}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <div className=''>
                    {tab[activeIndex].product}
                </div>
            </div>
        </div>
    )
}

export default FeatureProd